import script from "./VisionPlatform.vue?vue&type=script&setup=true&lang=js"
export * from "./VisionPlatform.vue?vue&type=script&setup=true&lang=js"

import "./VisionPlatform.vue?vue&type=style&index=0&id=c73f26ba&lang=css"

const __exports__ = script;

export default __exports__